import { useEffect, useRef } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { readSocketData } from 'shared/lib/fetchSocket';
import { shipmentTodoKey, detailReadStarted, detailReadReceived, detailReadFailed } from 'shared/store/slices/shipmentTodoSlice';

const EMPTY = [];

/**
 * Todo cards of the shipment open in a detail panel. They are read only while the panel is
 * open, and read again when a push changes that shipment or the socket reconnects.
 */
export const useShipmentTodos = (tab, parentId) => {
    const dispatch = useDispatch();
    const store = useStore();
    const key = shipmentTodoKey(tab, parentId);
    const entry = useSelector((state) => state.shipmentTodo.details[key]);
    const connected = useSelector((state) => state.socketStatus?.socketStatus);
    const epoch = useSelector((state) => state.socketStatus?.connectionEpoch);
    const changedAt = useSelector((state) => state.shipmentTodo.changedAt[key] ?? 0);
    const attempted = useRef(null);
    useEffect(() => {
        if (!connected || !parentId) return;
        const current = store.getState().shipmentTodo.details[key];
        if ((current?.pending && current.requestEpoch === epoch) ||
            (current?.epoch === epoch && !current.stale)) return;
        const attempt = `${key}:${epoch}:${changedAt}`;
        if (attempted.current === attempt) return;
        attempted.current = attempt;
        const startedRevision = store.getState().shipmentTodo.revision;
        dispatch(detailReadStarted({ key, epoch }));
        readSocketData(dispatch, tab, 'row', 'il_shipment_todo_detail', null, { parent_id: parentId },
            (cards) => dispatch(detailReadReceived({ key, cards, epoch, startedRevision })),
            () => dispatch(detailReadFailed({ key, epoch })));
    }, [dispatch, store, connected, epoch, tab, parentId, key, changedAt, entry?.pending, entry?.stale]);
    return entry?.cards ?? EMPTY;
};
